import { TProductTile } from 'widgets/product/ProductTile';
import { TButtonInstance } from 'widgets/global/Button';

/**
 * @param ProductTile Base widget for extending
 * @returns QuickShop Product Tile widget
 */
function QuickShopTileMixinClassCreator(ProductTile: TProductTile) {
    /**
     * @category widgets
     * @subcategory app_custom_core
     * @class QuickShopTileMixin
     * @augments ProductTile
     * @classdesc Overrides tile quick view to open a right-side flyout panel
     * instead of a centered dialog.
     */
    class QuickShopTileMixin extends ProductTile {
        /**
         * @description Opens the QuickShop flyout panel from the right
         * @param button Tile quick-view trigger button
         * @listens dom#click
         */
        showQuickView(button: TButtonInstance) {
            this.eventBus().emit('flyoutshow', {
                url: button.data('url'),
                wrapperClasses: 'm-quickshop',
                headerText: 'Quickshop',
                ariaLabel: this.prefs().productName,
                attributes: {
                    'data-tau-unique': 'quickshop_flyout'
                }
            }, this.onModalShow.bind(this));
        }
    }

    return QuickShopTileMixin;
}

export type TQuickShopTileMixin = ReturnType<typeof QuickShopTileMixinClassCreator>;

export type TQuickShopTileMixinInstance = InstanceType<TQuickShopTileMixin>;

export default QuickShopTileMixinClassCreator;
